module.exports = __webpack_public_path__ + "img/logo.8980c457.svg";